import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    branchStatistic: {},
    cards: {},
    transportType: {},
    usageType: {},
    actionType: {},
    owner: {},
    userStatistic: {},
    insuranceExpired: {},
    inspectionExpired: {},
    rentalPriceAvg: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchBranch = createAsyncThunk(
    'transportStatics/fetchBranch',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/branch-office?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchCardsStatistic = createAsyncThunk(
    'transportStatics/fetchCardsStatistic',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/cards?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchVehicleType = createAsyncThunk(
    'transportStatics/fetchVehicleType',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/vehicle-type?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchUsageType = createAsyncThunk(
    'transportStatics/fetchUsageType',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/usage-type?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchActionType = createAsyncThunk(
    'transportStatics/fetchActionType',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/action-type?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchOwner = createAsyncThunk(
    'transportStatics/fetchOwner',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/owner?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchUserStatistic = createAsyncThunk(
    'transportStatics/fetchUserStatistic',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/user?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchInsurance = createAsyncThunk(
    'transportStatics/fetchInsurance',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/insurance-expired?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchInspection = createAsyncThunk(
    'transportStatics/fetchInspection',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/inspection-expired?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchRentalPriceAvg = createAsyncThunk(
    'transportStatics/fetchRentalPriceAvg',
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const customHeaders = { Authorization: `Bearer ${token}` };

            const response = await request(
                `${APP_URL}/vehicles/statistics/rental-price-avg?${params}`,
                'GET',
                null,
                customHeaders
            );

            return { data: response.data || {} };
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);


const statisticSlice = createSlice({
    name: 'statistic',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranch.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchBranch.fulfilled, (state, action) => {
                state.branchStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchBranch.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchCardsStatistic.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchCardsStatistic.fulfilled, (state, action) => {
                state.cards = action.payload.data;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchCardsStatistic.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchVehicleType.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchVehicleType.fulfilled, (state, action) => {
                state.transportType = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchVehicleType.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchUsageType.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchUsageType.fulfilled, (state, action) => {
                state.usageType = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchUsageType.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchActionType.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchActionType.fulfilled, (state, action) => {
                state.actionType = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchActionType.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchOwner.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchOwner.fulfilled, (state, action) => {
                state.owner = action.payload.data;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchOwner.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchUserStatistic.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchUserStatistic.fulfilled, (state, action) => {
                state.userStatistic = action.payload.data;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchUserStatistic.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchInsurance.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchInsurance.fulfilled, (state, action) => {
                state.insuranceExpired = action.payload.data;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchInsurance.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchInspection.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchInspection.fulfilled, (state, action) => {
                state.inspectionExpired = action.payload.data;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchInspection.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchRentalPriceAvg.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchRentalPriceAvg.fulfilled, (state, action) => {
                state.rentalPriceAvg = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchRentalPriceAvg.rejected, (state) => {
                state.loadingStatus = 'error';
            })
    }
});

export default statisticSlice.reducer;